import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { ResetPasswordForm } from '@/features/auth/components/ResetPasswordForm';
import { PageTransition } from '@/shared/motion';

const searchSchema = z.object({
  token: z.string().min(1).optional(),
});

export const Route = createFileRoute('/_auth/user/reset-password')({
  validateSearch: (search) => searchSchema.parse(search),
  component: UserResetPasswordRoute,
});

function UserResetPasswordRoute() {
  const { token } = Route.useSearch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!token) {
    return (
      <PageTransition>
        <div className="rounded-md bg-warning-soft px-4 py-3 text-sm text-warning-foreground ring-1 ring-inset ring-warning/15">
          {t('auth.user.reset.missingToken')}
        </div>
      </PageTransition>
    );
  }

  return (
    <PageTransition>
      <ResetPasswordForm token={token} onSuccess={() => void navigate({ to: '/user/login' })} />
    </PageTransition>
  );
}
